"use strict";exports.name="@sainsburys-tech/fable",exports.version="4.17.1";
